import EATable from "../../EATable";
import React, {useCallback, useEffect, useState} from "react";
import {createColumn, createComponentColumn} from "../../../utils/ColumnUtils";
import {handleApiException, useHttp} from "../../../services/HttpService";
import EABetriebsakteMainContainer from "../EABetriebsakteMainContainer";
import {deleteAnforderung,} from "../../../services/AnforderungenService";
import usePathParam from "../../../utils/usePathParam";
import {NUMBER, STRING} from "../../../utils/URLUtils";
import EAButton from "../../EAButton";
import EAButtonBar from "../../EAButtonBar";
import EACrudDialog from "../../EACrudDialog";
import {
    getAnforderungEinheitenEndpoint,
    getAnforderungHaeufigkeitenEndpoint,
    getAnforderungProbenahmenEndpoint,
    getAnforderungsparameterEndpoint,
    getSelbstueberwachungVorlagenEndpoint,
    postAnforderung,
    putAnforderung
} from "../../../services/WertelistenService";
import {createSelstuebwerwachungSchema} from "../../../initialObjects/BescheidObjects";
import {usePreformattedHttp} from "../../../utils/usePreformattedHttp";
import {logger} from "../../../services/LogService";
import {toast} from "react-toastify";
import EATableActionButton from "../../tableComponents/EATableActionButton";
import useQueryParam from "../../../utils/useQueryParam";
import {getCurrentUser} from "../../../services/JwtService";
import {userHasAnyRole} from "../../../utils/SecurityUtils";
import {getJahresberichtByIDEndpoint} from "../../../services/AnlagenService";
import QuickLink from "../common/QuickLink";
import {useHistory} from "react-router-dom";
import {JAHRESBERICHT_PARAMETER_MESSWERTE} from "../../../consts/fachobjekt";
import cloneDeep from 'lodash/cloneDeep';
import {useConfirmation} from "../../ConfirmationDialog/ConfirmationDialogProvider";
import {StatusParameterMesswerte} from "../../../consts/valueLists";
import {BETREIBER, FACHADMIN, SYSTEMADMIN, ZUST_SBS} from "../../../consts/funktionaleRollen";


export default function MessstellenParameterListe(props) {
    const confirm = useConfirmation();
    const history = useHistory();
    const messstellenId = usePathParam("messstellenid", NUMBER);
    const berichtId = usePathParam("berichtid", NUMBER);
    const [usedMessstellenId, setUsedMessstellenId] = useState(-1);
    const [usedBerichtId, setUsedBerichtId] = useState(-1);
    const [{
        data,
        loading
    }, refetch] = useHttp("/jahresbericht/" + berichtId + "/messstelle/" + messstellenId + "/parameter-messwert", {manual: true});
    const [filteredData, setFilteredData] = useState(undefined);
    const [filteredDataErgaenzend, setFilteredDataErgaenzend] = useState(undefined);

    const [haeufigkeiten] = useHttp(getAnforderungHaeufigkeitenEndpoint(props.betriebstyp.id));
    const [selbstueberwachungVorlagen] = useHttp(getSelbstueberwachungVorlagenEndpoint());

    const [saveActionLoading, setSaveActionLoading] = useState(false);

    //eslint-disable-next-line
    const [_, refetchJahresbericht] = useHttp(getJahresberichtByIDEndpoint(berichtId), {manual: true});
    const [jahresbericht, setJahresbericht] = useState();


    const modus = useQueryParam("modus", STRING, "l");

    const parameterMapper = (data) =>
        data.map((o) => {
            return {id: o.parameterNr, value: o.parameterName};
        });

    const [parameter] = usePreformattedHttp(parameterMapper, getAnforderungsparameterEndpoint(props.betriebstyp.id, null));
    const [einheiten] = useHttp(getAnforderungEinheitenEndpoint(props.betriebstyp.id, null));
    const [probenahmen] = useHttp(getAnforderungProbenahmenEndpoint(props.betriebstyp.id, null));


    const [volatileAnforderung, setVolatileAnforderung] = useState({});
    const [dlgStatus, setDlgStatus] = useState({open: false});

    useEffect(() => {
        if (messstellenId && berichtId) {
            if (usedMessstellenId !== messstellenId || usedBerichtId !== berichtId) {
                setUsedMessstellenId(messstellenId);
                setUsedBerichtId(berichtId)
                refetch();
                setFilteredData(undefined);
                setFilteredDataErgaenzend(undefined);
                setJahresbericht(undefined);
                refetchJahresbericht().then(({data: valuesToSet}) => {
                    setJahresbericht(valuesToSet);
                }).catch((e) => {
                    handleApiException(e, "Error loading bericht");
                });
            }
        }
    }, [messstellenId, usedMessstellenId, usedBerichtId, refetch, berichtId, refetchJahresbericht, props]);

    useEffect(() => {
        const isPlausibilisiert = jahresbericht?.status && jahresbericht.status === "PLAUSIBILISIERT";
        const isEingereicht = jahresbericht?.status && jahresbericht.status === "EINGEREICHT";

        var isEditAllowed = userHasAnyRole([BETREIBER, ZUST_SBS, FACHADMIN, SYSTEMADMIN])
            && (!userHasAnyRole(BETREIBER) || (userHasAnyRole(BETREIBER) && !isEingereicht))
            && !isPlausibilisiert;


        if (isEditAllowed) {
            props.setToggleAllowed(true);
        } else {
            props.setToggleAllowed(false);
        }
    }, [jahresbericht, props]);

    function formatTimestamp(timestamp) {
        const date = new Date(timestamp);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }

    const transformedData = data?.map(item => {
        const newItem = {...item};
        for (let key in newItem) {
            if (newItem[key] && typeof newItem[key] === 'object' && newItem[key].hasOwnProperty('value')) {
                newItem[key] = newItem[key].value;
            }
        }
        if (item.grundlage) {
            newItem.grundlage = item.grundlage
        }
        if (item.parameterNr) {
            newItem.parameter = item.parameterNr.value;
        }
        if (item.haeufigkeit) {
            newItem.haeufigkeit = item.haeufigkeit;
        }
        if (item.probenahme) {
            newItem.probenahme = item.probenahme;
        }
        if (item.anforderungsParameterArt) {
            newItem.anforderungsParameterArt = item.anforderungsParameterArt;
        }
        if (item.gueltigVon) {
            newItem.gueltigVon = formatTimestamp(item.gueltigVon);
        }
        if (item.gueltigBis) {
            newItem.gueltigBis = formatTimestamp(item.gueltigBis);
        }
        if (item.wert) {
            newItem.wert = item.wert;
        }
        if (item.anzahlWerte) {
            newItem.anzahlWerte = item.anzahlWerte;
        }
        if (item.status) {
            const statusParam = StatusParameterMesswerte.find(v => v.id === item.status)
                ?? (() => { throw new Error(`Status ${item.status} nicht gefunden`); })();

            newItem.status = statusParam.value;
        }
        return newItem;
    });


    useEffect(() => {
        if (transformedData && !filteredData && !loading) {
            setFilteredData([
                ...transformedData.filter((item) => {
                    return (item.anforderungArt === "SELBSTUEBERWACHUNGSAUFLAGE");
                }),
            ]);
        }
    }, [transformedData, filteredData, loading]);

    useEffect(() => {
        if (jahresbericht && transformedData && !filteredDataErgaenzend && !loading) {
            setFilteredDataErgaenzend([
                ...transformedData.filter((item) => {
                    return item.anforderungsParameterArt === "Ergänzend" && item.jahresbericht.id === jahresbericht.id;
                }),
            ]);
        }
    }, [transformedData, filteredDataErgaenzend, loading, jahresbericht]);

    function openDialog() {
        setVolatileAnforderung({});
        setDlgStatus({open: true});
    }

    function handleDlgOpen(anforderung, index, readOnly = false) {
        setVolatileAnforderung({...data.find(objekt => objekt.id === anforderung.id), index});
        setDlgStatus({open: true, readOnly: readOnly});
    }

    function closeDialog() {
        setDlgStatus({open: false});
    }

    function handleSaveAnforderung(newAnforderung) {
        closeDialog();
        saveAsAdmin(newAnforderung).then(() => {
            setUsedMessstellenId(-1);
        });
    }

    const prepareForUpload = (values) => {
        const anforderung = cloneDeep(values);
        anforderung.id = anforderung.anforderungId;
        anforderung.parameterNr = anforderung.parameterNr?.id;
        anforderung.probenahme = anforderung.probenahme?.id;
        anforderung.haeufigkeit = anforderung.haeufigkeit?.id;
        anforderung.einheit = anforderung.einheit?.id;
        anforderung.einheitAbfluss = anforderung.einheitAbfluss?.id;
        anforderung.einheitKonz = anforderung.einheitKonz?.id;
        anforderung.vorlageMesswerte = anforderung.vorlageMesswerte?.id;
        anforderung.messstelle = messstellenId;
        anforderung.anforderungArt = "ERGAENZEND";
        anforderung.parameterArt = "ERGAENZEND";
        anforderung.jahresbericht = jahresbericht;
        anforderung.gueltigAb = anforderung.gueltigVon;

        if (!anforderung.erstelltVon) {
            anforderung.erstelltVon = getCurrentUser();
            anforderung.erstelltVon.benutzername = anforderung.erstelltVon?.sub;
        }
        return anforderung;
    };

    const buildDefaultColumns = useCallback(() => {
        return [
            createColumn("grundlage", "Grundlage"),
            createComponentColumn("parameter", (row) => <QuickLink fachobjektbezug={JAHRESBERICHT_PARAMETER_MESSWERTE}
                                                                   fachobjektId={row.id}
                                                                   title={row.parameter}
                                                                   history={history}
                                                                   loading={loading}
                                                                   hasFirstLevelEntlastungsanlagen={false}
                                                                   setLoading={() => {}}
                                                                   />,
                "Parameter"),
            createColumn("status", "Status"),
            createColumn("anforderungsParameterArt", "Parameterart"),
            createColumn("vorlageMesswerte", "Vorlage"),
            createColumn("probenahme.value", "Probenahmeart"),
            createColumn("anzahlWerte", "Anzahl"),
            createColumn("gueltigVon", "von"),
            createColumn("gueltigBis", "bis")
        ];
    }, [history, loading]);

    const buildInnerColumns = () => createComponentColumn(
        "actions",
        (row, index) => {
            return (
                <div className="eatabwrapper">
                    {
                        <EATableActionButton id={"abs-" + index} iconName="ico-edit">
                            <span onClick={() => handleDlgOpen(row, index)}/>
                        </EATableActionButton>
                    }
                </div>
            );
        },
        "",
        null,
        {padding: 0, width: "50px", minWidth: "50px", maxWidth: "50px"}
    );

    const buildColumns = () => [
        buildInnerColumns(),
        ...buildDefaultColumns(),
    ];

    const saveAsAdmin = async (anforderung) => {
        setSaveActionLoading(true);
        const objectToSave = prepareForUpload(anforderung);
        logger.debug("SaveAsAdmin", objectToSave);
        try {
            if (anforderung.id) {
                await putAnforderung(objectToSave);
            } else {
                await postAnforderung(objectToSave);
            }
            toast.success("Anforderung erfolgreich gespeichert");
            setSaveActionLoading(false);
        } catch (ex) {
            setSaveActionLoading(false);
            const response = ex?.response;
            if (!response) {
                return;
            }
            if (response?.data?.validationErrors) {
                const errorMessage = Object.values(response.data.validationErrors)[0];
                toast.warn("Validierung fehlgeschlagen: " + errorMessage);
            }
        }
    };

    const handleDeleteAnforderung = async () => {
        if (!(volatileAnforderung.erstelltVon && userHasAnyRole([...volatileAnforderung.erstelltVon.funktionaleRolle]))) {
            toast.warn("Keine Berechtigung vorhanden");
            return;
        }

        closeDialog();
        if (saveActionLoading) return;
        setSaveActionLoading(true);
        try {
            await deleteAnforderung(volatileAnforderung.id);
            toast.success("Anforderung erfolgreich gelöscht");
            refetch();
            setFilteredData(undefined);
            setFilteredDataErgaenzend(undefined);
            setSaveActionLoading(false);
        } catch (ex) {
            setSaveActionLoading(false);
            const response = ex?.response;
            if (!response) {
                return;
            }
            let newErrors = null;
            if (response?.data?.validationErrors) {
                const errorMessage = Object.values(response.data.validationErrors)[0];
                toast.warn("Validierung fehlgeschlagen: " + errorMessage);
                newErrors = ex.response.data.validationErrors;
            }
            if (!newErrors) {
                handleApiException(ex);
            }
        }
    }

    return (
        <div className={"viewScrollContainer"}>
            <EABetriebsakteMainContainer className={"tabsheet-content-margin"}>
                <h2>Selbstüberwachungsauflagen im Berichtsjahr</h2>
                <EATable columns={buildDefaultColumns()} data={filteredData} loading={loading || saveActionLoading || !transformedData}/>
                <h2>Ergänzende Parameter im Berichtsjahr</h2>
                <EATable
                    columns={modus === "s" && jahresbericht && jahresbericht.status !== "PLAUSIBILISIERT" ? buildColumns() : buildDefaultColumns()}
                    data={filteredDataErgaenzend} loading={loading || saveActionLoading || !transformedData}/>
                <EAButtonBar style={{
                    marginBottom: '10px',
                    marginTop: '10px'
                }}>
                    {modus === "s" && jahresbericht && jahresbericht.status !== "PLAUSIBILISIERT" && (
                        <EAButton
                            id={"addErgaenzend"}
                            loading={loading || saveActionLoading}
                            disabled={loading}
                            label="Hinzufügen"
                            onClick={() => openDialog()}
                        />
                    )}
                </EAButtonBar>
                <EACrudDialog
                    open={dlgStatus.open}
                    schema={createSelstuebwerwachungSchema()}
                    readOnly={false}
                    title={"Ergänzender Parameter"}
                    submitTitle="Speichern"
                    onClose={() => closeDialog()}
                    obj={volatileAnforderung}
                    onSaveobj={(o) => handleSaveAnforderung(o)}
                    buildContent={(formFactory) =>
                        buildErgaenzendeParameterContent(
                            formFactory,
                            parameter,
                            probenahmen,
                            haeufigkeiten,
                            einheiten,
                            selbstueberwachungVorlagen
                        )}
                    renderAdditionalActions={() =>
                        (
                            <EAButton
                                id="deleteAnforderung"
                                label="Löschen"
                                style={{marginRight: "auto"}}
                                onClick={() => {
                                    confirm({
                                        title: "Löschen bestätigen",
                                        description: "Soll der Parameter wirklich gelöscht werden?",
                                        onSubmit: () => {
                                            handleDeleteAnforderung();
                                        },
                                        onClose: () => {
                                        },
                                    });
                                }}
                            />
                        )
                    }
                />
            </EABetriebsakteMainContainer>
        </div>
    );
}

function buildErgaenzendeParameterContent(formFactory, parameter, probenahmen, haeufigkeiten, einheiten, vorlageMesswerte) {
    return (
        <div className="gridl" style={{gridTemplateColumns: "1fr 1fr"}}>
            {formFactory.renderAutocomplete(
                "parameterNr",
                "parameterNr",
                "Parameter",
                parameter.data,
                (o) => o.id + ", " + o.value,
                "id",
                parameter.loading,
                false,
                false,
                {
                    style: {gridColumn: "span 2"},
                }
            )}
            {formFactory.renderAutocompleteWerteliste("probenahme", "probenahme", "Probenahme", probenahmen, false, false, {
                style: {gridColumn: "span 2"},
            },
            null,
            false)}
            {formFactory.renderAutocompleteWerteliste("haeufigkeit", "haeufigkeit", "Häufigkeit", haeufigkeiten, false, false, {
                style: {gridColumn: "span 2"},
            })}
            {formFactory.renderAutocompleteWerteliste("einheit", "einheit", "Einheit", einheiten, false, false, {
                style: {gridColumn: "span 2"}
            })}
            {formFactory.renderAutocompleteWerteliste("einheitAbfluss", "einheitAbfluss", "Einheit Abfluss (Frachtberechnung)", einheiten, false, false, {
                style: {gridColumn: "span 2"},
            })}
            {formFactory.renderAutocompleteWerteliste("einheitKonz", "einheitKonz", "Einheit Konz. (Frachtberechnung)", einheiten, false, false, {
                style: {gridColumn: "span 2"},
            })}
            {formFactory.renderAutocompleteWerteliste("vorlageMesswerte", "vorlageMesswerte", "Vorlage Messwerte", vorlageMesswerte, false, false, {
                style: {gridColumn: "span 2"},
            })}
            {formFactory.renderDatePicker("gueltigVon", "gueltigVon", "Gültig ab")}
            {formFactory.renderDatePicker("gueltigBis", "gueltigBis", "Gültig bis")}
            {formFactory.renderInput("zusatztext", "zusatztext", "Zusatztext", "text", false, {
                style: {gridColumn: "span 2"},
                inputProps: {maxLength: 100},
                multiline: true,
                rows: 4,
            })}
        </div>
    );
}
